<template>
  <div class="v-users-iban">
    <b-card class="content-card">
      <div fluid>
        <b-skeleton-table
          v-if="loading"
          :rows="5"
          :columns="5"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>
        <b-table
          v-if="!loading"
          :items="results"
          :fields="fields"
          empty-text="موردی یافت نشد"
          stacked="md"
          show-empty
          small
        >
          <template #cell(accountInfo)="row">
            <b-button
              @click="$router.push(`/user-profile/${row.value.id}`)"
              size="sm"
              variant="primary"
            >
              {{ row.value.user }}
            </b-button>
          </template>

          <template #cell(status)="row">
            در انتظار بررسی
          </template>

          <template #cell(actions)="row">
            <div class="d-flex flex-wrap">
              <b-button
                class="mr-1"
                variant="success"
                size="sm"
                @click="verifyCard(row.item.id, row.item.accountInfo.id)"
                v-if="row.item.status !== 'Approved'"
              >
                تایید کارت
              </b-button>

              <b-button
                class="mr-1"
                variant="danger"
                size="sm"
                @click="rejectCard(row.item.id, row.item.accountInfo.id)"
                v-if="row.item.status !== 'Rejected'"
              >
                رد کارت
              </b-button>
            </div>
          </template>

        </b-table>
      </div>
    </b-card>
  </div>
</template>

<script>
import http from "@/httpservices/HttpService";

export default {
  name: "UsersIban",
  data() {
    return {
      results: [],
      loading: true,
      token: localStorage.getItem("token") || "",

      fields: [
        {
          key: "accountInfo",
          label: "نام کاربر",
          sortable: true,
          class: "text-right",
        },
        {
          key: "holderName",
          label: "نام ثبت شده کارت",
          sortable: true,
          class: "text-right",
        },
        {
          key: "card",
          label: "شماره کارت",
          sortable: true,
          class: "text-right",
        },
        {
          key: "status",
          label: "وضعیت",
          sortable: true,
          class: "text-right",
        },
        { key: "actions", label: "عملیات", class: "text-right" },
      ],
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      this.loading = true;

      http
        .get(`/BankCards/none-status/list`, {
          params: {
            page: 0,
            perPage: 100,
          },
        })
        .then(async (response) => {
          const getUserName = (user) => {
            if (user.firstName && user.lastName) {
              return user.firstName + " " + user.lastName;
            }
            return "مشاهده اطلاعات کاربری";
          };
          this.results = await Promise.all(
            response.data.map(async (item) => {
              const { data } = await http.get("/Accounts/" + item.accountId);
              return {
                id: item.id,
                accountInfo: {
                  id: item.accountId,
                  user: getUserName(data),
                },
                holderName: item.holderName,
                card: item.cardNumber,
                status: item.status,
              };
            })
          );
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },

    verifyCard(id, userId) {
      const confirm = window.confirm("آیا مطمئن هستید ؟ ");
      if (!confirm) {
        return;
      }
      http
        .put("/BankCards/" + id + "/account/" + userId + "/approve")
        .then(() => {
          this.getData();
        })
        .catch((err) => {
          if (err.response) {
          }
        });
    },

    rejectCard(id, userId) {
      const confirm = window.confirm("آیا مطمئن هستید ؟ ");
      if (!confirm) {
        return;
      }
      http
        .put("/BankCards/" + id + "/account/" + userId + "/reject")
        .then(() => {
          this.getData();
        })
        .catch((err) => {
          if (err.response) {
          }
        });
    },
  },
};
</script>

<style lang="scss">
.v-users-iban {
  padding: 16px;
}
</style>
